import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import HomeslayLanding from './Components/Hero/Hero';
import Workflow from './Components/WorkflowSection/WorkflowSection';
import Footer from './Components/Footer/Footer';
import Contact from './Components/ContactUs/ContactPage';
import Header from './Components/Header/Header';
import FAQSection from './Components/FAQSection/FAQSection';
import { Features } from './Components/Features/Features';
import Benefits from './Components/Benifits/Benifits';

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="App">
              <Header />

              <div id="home">
                <HomeslayLanding />
              </div>

              <div id="features">
                <Features />
              </div>

              <div id="workflow">
                <Workflow />
              </div>

              <div id="benefits">
                <Benefits />
              </div>

              <div id="faq">
                <FAQSection />
              </div>

              <div id="contact">
                <Contact />
              </div>

              <div id="footer">
                <Footer />
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;